/** @jsxImportSource @emotion/react */

import { searchOrdersQueryDocument } from 'api/graphql';
import { useMemo, useState } from 'react';
import { useQuery } from 'urql';

import { SearchFilter, SearchFilterOption, SearchFilterProps } from './SearchFilter';

export type OrderFilterProps = {
  merchantIds: string | string[];
  value: SearchFilterOption | null;
  onChange(value: SearchFilterOption | null): void;
  searchDescription?: boolean;
};

export function OrderFilter({ merchantIds, value, onChange, searchDescription, ...props }: OrderFilterProps) {
  const [query, setQuery] = useState('');

  const pause = query.length < 3;

  const [{ fetching, data, error }] = useQuery({
    query: searchOrdersQueryDocument,
    variables: { merchantIds, query },
    pause,
  });

  const options = useMemo<SearchFilterProps['options']>(() => {
    if (pause || !data?.orders) return [];

    return data.orders.edges.map(({ node: { orderId, referenceOrderId, description } }) => ({
      value: orderId,
      label: searchDescription ? description ?? referenceOrderId : referenceOrderId,
    }));
  }, [data?.orders, pause, searchDescription]);

  return (
    <SearchFilter
      value={value}
      options={options}
      placeholder={`Search ${searchDescription ? 'description' : 'order ID'}`}
      loading={fetching}
      error={error?.message}
      onChange={onChange}
      onInputChange={setQuery}
    />
  );
}
